import React, { useState, useRef } from 'react';
import { Grid, Box } from '@mui/material';

function SupportingDocumentWithBoundingBoxes({
  lineItemsArray,
  dTUrl,
  dtIndex,
  imageDimensions,
  setImageDimensions,
  selectedItemIndex
}) {
  const [isZoomed, setIsZoomed] = useState(false);
  const imgRef = useRef(null);

  const handleImageLoad = () => {
    if (!imgRef.current) return;

    setImageDimensions({
      width: imgRef.current.offsetWidth,
      height: imgRef.current.offsetHeight
    });
  };

  const toggleZoom = () => setIsZoomed((prev) => !prev);

  const filteredItemsArray = lineItemsArray?.map((row) =>
    row?.filter(
      (item) =>
        (item?.name === 'Description' || item?.name === 'Quantity') &&
        (item.page === dtIndex || item?.page === '-' || item?.page === '')
    )
  );

  return (
    <>
      {/* Overlay */}
      {isZoomed && (
        <Box
          onClick={toggleZoom}
          sx={{
            position: 'fixed',
            inset: 0,
            bgcolor: 'rgba(0,0,0,0.6)',
            zIndex: 1400
          }}
        />
      )}

      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{
          position: 'relative',
          width: '100%',
          height: '100%'
        }}>
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            height: '100%',
            maxWidth: '100%',
            maxHeight: '100%'
          }}>
          <Box
            component="img"
            ref={imgRef}
            src={dTUrl[dtIndex]}
            alt={`invoice-${dtIndex}`}
            onClick={toggleZoom}
            onLoad={handleImageLoad}
            sx={{
              cursor: 'pointer',
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              display: 'block'
            }}
          />

          {/* Zoomed overlay */}
          {isZoomed && (
            <Box
              component="img"
              src={dTUrl[dtIndex]}
              alt={dtIndex}
              onClick={toggleZoom}
              sx={{
                cursor: 'pointer',
                position: 'fixed',
                inset: 0,
                width: '100vw',
                height: '100vh',
                objectFit: 'contain',
                zIndex: 1500,
                bgcolor: 'rgba(0,0,0,0.6)'
              }}
            />
          )}

          {/* Bounding boxes */}
          {!isZoomed &&
            filteredItemsArray?.map((element, parentIndex) =>
              element?.map((items, idx) => {
                const isSelected =
                  selectedItemIndex === 'button_' + items.value + '**%**' + parentIndex + idx;

                return (
                  <Box
                    key={`${parentIndex}-${idx}`}
                    sx={{
                      position: 'absolute',
                      top: items.top * imageDimensions.height,
                      left: items.left * imageDimensions.width,
                      width: items.width * imageDimensions.width,
                      height: items.height * imageDimensions.height,
                      bgcolor: isSelected ? '#00FF3C' : 'transparent',
                      opacity: isSelected ? 0.35 : 0,
                      pointerEvents: 'none',
                      zIndex: 10
                    }}
                  />
                );
              })
            )}
        </Box>
      </Grid>
    </>
  );
}

export default SupportingDocumentWithBoundingBoxes;
